import { AuditLink } from '@optools/components/audit-link';
import { CopyText } from '@optools/components/copy-text';
import { Badge } from '@optools/components/ui/badge';
import { BtcScheduleContent } from '@optools/services/operator-gateway/btc/types';
import { MediaType } from '@optools/services/operator-gateway/types/generated/graphql';
import { Speaker, Video } from 'lucide-react';

import { MediaStateSelect } from './media-state-select';

export interface MediaDetailProps {
  actionButton?: React.ReactNode;
  content: BtcScheduleContent;
  gamePk: number;
}

export function MediaDetails({ actionButton, content, gamePk }: MediaDetailProps) {
  const { callSign, feedType, language, mediaId, mediaState } = content;
  const isVideo = mediaState?.mediaType === MediaType.VIDEO;

  return (
    <div className="flex items-center justify-between gap-8 overflow-x-auto">
      <div className="flex-1 p-2">
        <div className="grid grid-cols-[auto_256px_80px_80px_144px_80px_1fr] gap-8">
          <div className="whitespace-nowrap">
            <h3 className="mb-6 text-sm font-bold">Media Type</h3>
            <Badge variant={isVideo ? 'default' : 'secondary'}>
              {isVideo ? <Video /> : <Speaker />} {mediaState?.mediaType}
            </Badge>
          </div>
          <div className="items-center whitespace-nowrap">
            <h3 className="mb-5 text-sm font-bold">Media ID</h3>
            {mediaId ? (
              <CopyText textToCopy={mediaId}>
                <AuditLink tag="mediaId" value={mediaId} />
              </CopyText>
            ) : (
              <p className="text-xs">UNKNOWN</p>
            )}
          </div>

          <div className="whitespace-nowrap">
            <h3 className="mb-6 text-sm font-bold">Feed Type</h3>
            <p className="text-xs">{feedType}</p>
          </div>

          <div className="whitespace-nowrap">
            <h3 className="mb-6 text-sm font-bold">Call Sign</h3>
            <p className="text-xs">{callSign ?? 'N/A'}</p>
          </div>

          <div className="whitespace-nowrap">
            <h3 className="mb-6 text-sm font-bold">Content Experience</h3>
            <p className="text-xs">{mediaState?.contentExperience}</p>
          </div>

          <div>
            <h3 className="mb-5.5 flex items-center gap-2 text-sm font-bold">Language</h3>
            <span className="text-xs font-semibold uppercase">{language}</span>
          </div>

          <div className="w-32">
            <h3 className="mb-4 flex items-center gap-1 text-sm font-bold">State</h3>
            <MediaStateSelect content={content} gamePk={gamePk} />
          </div>
        </div>
      </div>
      {actionButton}
    </div>
  );
}
